import { SxProps } from '@mui/material';

export const LogoStyles: SxProps = {
  height: '30px',
  cursor: 'pointer',
};
